$(document).ready(function() {
  $('.show-more__button').click(function() {
    $('.show-more p').slideToggle('fast');
    $(this).toggleClass('arrow-reverse');
    $(this).children('span').toggleClass('show-text');

  });
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/show-more.js
 ** module id = 132
 ** module chunks = 0
 **/